export function isE2ETest(): boolean {
  // testcafe sets this window variable when running
  // This works better than checking user-agent so that
  // remote browsers are also detected when running locally
  // @ts-expect-error
  return typeof window["%testCafeCore%"] !== "undefined"
}
